import React, { useState, useEffect } from 'react';
import * as styles from '../styles/components/modal.css.ts';
import { Dialog } from './common/Dialog';
import { Button } from './common/Button';

interface CommentModalProps {
  isOpen: boolean;
  initialComment?: string;
  rowData?: Array<{ rowNumber: number; values: Record<string, unknown> }>;
  onSave: (comment: string) => void;
  onCancel: () => void;
}

export const CommentModal: React.FC<CommentModalProps> = ({
  isOpen,
  initialComment = '',
  rowData,
  onSave,
  onCancel
}) => {
  const [comment, setComment] = useState(initialComment);

  useEffect(() => {
    setComment(initialComment);
  }, [initialComment, isOpen]);

  const handleSave = () => {
    onSave(comment.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCancel}
      title={
        `${initialComment ? 'Edit Comment' : 'Add Comment'}${rowData && rowData.length > 1 ? ` for ${rowData.length} rows` : ''}`
      }
      width="md"
      data-testid="comment-modal"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </>
      }
    >
      <div>
        {/* 行データを表示 */}
        {rowData && rowData.length > 0 && (
          <div className={styles.rowPreview}>
            <div className={styles.previewTitle}>
              {rowData.length === 1 ? 'Data for this row:' : `Data for ${rowData.length} rows:`}
            </div>
            <div className={styles.previewContent}>
              {rowData.map((row, index) => (
                <div key={index} className={styles.previewRow}>
                  {Object.entries(row.values).map(([key, value], i) => {
                    const displayValue = value == null ? '' : String(value);
                    const truncatedValue = displayValue.length > 50
                      ? displayValue.substring(0, 50) + '...'
                      : displayValue;

                    return (
                      <div key={i} className={styles.columnValue}>
                        <span className={styles.columnName}>{key}:</span>
                        <span className={styles.columnData}>{truncatedValue || '(empty)'}</span>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        )}

        <label className={styles.label}>
          Comment:
        </label>
        <textarea
          className={styles.commentTextarea}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Enter your comment here..."
          autoFocus
          rows={5}
        />
      </div>
    </Dialog>
  );
};